import React from 'react';
import { BookOpenIcon, LockIcon, DownloadIcon } from 'lucide-react';
export function SiteFooter() {
  return <footer className="bg-cream py-14" data-id="element-152" data-mp="3r7zmzju1qka7">
      <div className="mx-auto max-w-3xl px-5 text-center md:px-8" data-id="element-153" data-mp="3r917eewycj4l">
        <div className="flex items-center justify-center gap-2" data-id="element-154" data-mp="3mghmsxzuknqa">
          <BookOpenIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-155" data-mp="3hipsjxbqcpix" />
          <p className="font-serif text-2xl font-semibold text-ink" data-id="element-156" data-mp="3hglsjqgycanx">El Poder de los Salmos</p>
        </div>
        <p className="mt-3 text-muted" data-id="element-157" data-mp="3dei5s5ou1jnc">Un espacio para la Palabra, la reflexión y el crecimiento espiritual.</p>
        <p className="mt-2 font-serif text-lg italic text-gold-dark" data-id="element-158" data-mp="33if2gwi8veyt">
          Que cada lectura sea una oportunidad para detenerte, agradecer y seguir caminando con fe.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 border-t border-line pt-6 text-sm text-muted sm:flex-row sm:gap-6" data-id="element-159" data-mp="2ylyga7ulvaod">
          <span data-id="element-160" data-mp="wta8dl70nz29">© 2026 · Todos los derechos reservados.</span>
          <span className="flex items-center gap-1.5" data-id="element-161" data-mp="15qva55gw0thu">
            <LockIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-162" data-mp="15pae1bexd2hv" /> Compra segura
          </span>
          <span className="flex items-center gap-1.5" data-id="element-163" data-mp="1arj86b3jaalk">
            <DownloadIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-164" data-mp="vt7ca6nzj5vg" /> Producto digital
          </span>
        </div>
      </div>
    </footer>;
}